<template>
    <v-row>
        <v-col lg=3 sm=6 md=4 cols=12>
            <v-card height="200" class="support-card ma-1" >
                <v-card-title class="d-flex flex-nowrap pa-5 pb-0">
                    <p class="text-truncate" style="cursor: pointer" @click="onShowOrgBtn">Мои организации</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                    <v-row no-gutters class="pb-0">
                        <v-col cols="5" class="my-auto">
                        <span class="font-weight-medium greyBold--text" style="font-size: 24px;">{{COUNT_ORGANIZATIONS}}</span>
                        <p class="greyBold--text mb-0">Кол-во</p>
                        </v-col>
                        <v-col cols="6">
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-col class="text-right">
                        <v-btn
                            class=""
                            color="success"
                            text
                            @click="onAddOrgBtn"
                        >
                            <v-icon size="45">mdi-plus-circle-outline</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="(COUNT_ORGANIZATIONS > 0)"
                            class=""
                            color="success"
                            text
                            @click="onShowOrgBtn"
                        >
                            <v-icon size="45">mdi-eye-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col lg=3 sm=6 md=4 cols=12>
            <social-widget height="200"></social-widget>
        </v-col>
        <v-col lg=3 sm=6 md=4 cols=12>
            <maintenance-widget height="200"></maintenance-widget>
        </v-col>
        <v-col lg=3 sm=6 md=4 cols=12>
            <api-widget height="200" />
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from 'vuex';
import SocialWidget from '@/app/widgets/SocialWidget.vue';
import MaintenanceWidget from '@/app/pages/Maintenance/MaintenanceWidget.vue';
import ApiWidget from "../widgets/ApiWidget.vue";
export default {
    name: 'Main',
    components:{
        ApiWidget,
        SocialWidget, MaintenanceWidget
    },
    data(){
        return {
        }
    },
    methods: {
        onAddOrgBtn(){
            this.$router.push({name: 'OrganizationAdd'})
        },
        onShowOrgBtn(){
            this.$router.push({name: 'Organizations'})
        },
    },
    computed: {
        ...mapGetters( 'workspace', ['COUNT_ORGANIZATIONS' , 'ORGANIZATION_DEBT_RESULTS_STATUS']),
    }
}
</script>